module.exports = __webpack_public_path__ + "img/omw-icon.9800feec.svg";